module.exports = __webpack_public_path__ + "img/bleu-4.39fa6aa5.png";